// Copied from platform-app components/pos/receipt/blockDefaults.ts on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
import type { ReceiptBlock } from '@platform/shared-types';

// MUST stay in sync with @platform/shared-types `MAX_TOTAL_BLOCKS`. Kept as a literal here
// because shared-types is built CJS and Vite can't re-export runtime named bindings from it.
export const MAX_TOTAL_BLOCKS = 20;

// Mirror of @platform/shared-types `DEFAULT_BUSINESS_DETAIL_STYLES`. Same CJS/ESM reason
// as above — keep these two in sync (the schema doesn't enforce defaults, render code does).
export const DEFAULT_BUSINESS_DETAIL_STYLES = {
  legalName:    { size: 'L' as const,  align: 'C' as const, bold: true,  italic: false, underline: false },
  addressLine1: { size: 'N' as const,  align: 'C' as const, bold: false, italic: false, underline: false },
  addressLine2: { size: 'N' as const,  align: 'C' as const, bold: false, italic: false, underline: false },
  addressLine3: { size: 'N' as const,  align: 'C' as const, bold: false, italic: false, underline: false },
  phone:        { size: 'N' as const,  align: 'C' as const, bold: false, italic: false, underline: false },
};

const newId = () => `b_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;

export const BLOCK_TYPES = ['text', 'boxed', 'logo', 'image', 'qr', 'divider', 'spacer'] as const;
export type BlockType = (typeof BLOCK_TYPES)[number];

export const BLOCK_LABELS: Record<BlockType, { label: string; icon: string }> = {
  text:    { label: 'Text', icon: '📝' },
  boxed:   { label: 'Boxed Announcement', icon: '🎁' },
  logo:    { label: 'Logo', icon: '🖼️' },
  image:   { label: 'Image', icon: '🖼' },
  qr:      { label: 'QR Code', icon: '▦' },
  divider: { label: 'Divider', icon: '─' },
  spacer:  { label: 'Spacer', icon: '⤓' },
};

export function makeBlock(type: BlockType): ReceiptBlock {
  switch (type) {
    case 'text':    return { id: newId(), type, content: 'New text', size: 'N', align: 'C', bold: false, italic: false, underline: false, inverse: false, spacingAbove: 'none' };
    case 'boxed':   return { id: newId(), type, content: 'Announcement', size: 'L', align: 'C', bold: true, borderStyle: 'dashed', spacingAbove: 'none' };
    case 'logo':    return { id: newId(), type, align: 'C', maxWidth: 'M', spacingAbove: 'none' };
    case 'image':   return { id: newId(), type, imageUrl: '', align: 'C', maxWidth: 'M', spacingAbove: 'none' };
    case 'qr':      return { id: newId(), type, data: '', align: 'C', size: 'M', caption: null, spacingAbove: 'none' };
    case 'divider': return { id: newId(), type, style: 'dashed', spacingAbove: 'none' };
    case 'spacer':  return { id: newId(), type, height: 'M' };
  }
}
